import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M19.35,14a3.08,3.08,0,0,1-2.85-1.57.24.24,0,0,0-.44.07l-1.58,5a1.49,1.49,0,0,1-1.46,1,1.48,1.48,0,0,1-1.44-1.05L9.26,8.8a.25.25,0,0,0-.49,0,14.42,14.42,0,0,1-1.2,3.75A2.82,2.82,0,0,1,4.87,14H.17a12,12,0,0,0,23.66,0Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M4.87,12c.94,0,1,0,1.92-3.56.2-.82.45-1.78.75-2.9A1.49,1.49,0,0,1,9,4.5H9a1.47,1.47,0,0,1,1.45,1l2.4,8.93a.25.25,0,0,0,.48,0l1.35-4.29a1.49,1.49,0,0,1,1.35-1,1.51,1.51,0,0,1,1.44.78l.29.56c.58,1.17.75,1.45,1.59,1.45H24A12,12,0,0,0,0,12Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }